import { html, View } from 'rune-ts';
import { FundingListResponse } from '@services/MarppleShop/features/Funding';
import {
  FundingCard,
  FundingCardProps,
} from '@services/MarppleShop/renderApp/components/cells/FundingCard/FundingCard.ts';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';
import klass from './MainPageFundingSection.module.scss';

interface MainPageFundingSectionProps {
  funding_lists: FundingListResponse;
  server_timestamp: number;
  is_mobile: boolean;
}

export class MainPageFundingSection extends View<MainPageFundingSectionProps> {
  override template() {
    return html`
      <div class="${klass.root}">
        <div class="${klass.title_wrap}">
          ${new SectionTitle({
            title_props: {
              title: this.i18n.title,
              size: this.data.is_mobile ? 'medium' : 'xLarge',
              theme: 'light',
            },
          })}
        </div>
        <div class="${klass.list_container}">
          ${this.getFundingCardProps().map((funding) => {
            return new FundingCard(funding);
          })}
        </div>
      </div>
    `;
  }

  private get i18n() {
    return {
      title: ET('mps2::main::funding_title'),
    };
  }

  getFundingCardProps(): FundingCardProps[] {
    return this.data.funding_lists.data.map((item) => ({
      product_id: item.productId,
      name: item.name,
      domain_name: item.domainName,
      thumbnail_info: item.thumbnailInfo,
      description: item.description,
      sell_start_at: item.sellStartAt,
      sell_end_at: item.sellEndAt,
      goal_amount: item.goalAmount,
      total_amount: item.totalAmount,
      is_quantity_public: item.isQuantityPublic,
      is_public: item.isPublic,
      order_count: item.orderCount,
      quantity: item.quantity,
      out_of_stock: item.outOfStock,
      server_timestamp: this.data.server_timestamp,
      is_mobile: this.data.is_mobile,
    }));
  }
}
